import { useContext } from 'react';
import TileButton from '../components/TileButton';
import { InteractionContext } from '../../../contexts';

const InviteSpouse = () => {
  const { values, handleChange } = useContext(InteractionContext);

  return (
    <>
      {values.answers.map((answer, i) => (
        <TileButton
          key={`invite_spouse_button_${i}`}
          buttonText={answer}
          buttonIndex={i}
          onChangeButtonText={handleChange}
        />
      ))}
    </>
  );
};

export default InviteSpouse;
